import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=3faec9e7&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=3faec9e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faec9e7",
  null
  
)

export default component.exports